import React from 'react';
import styled from 'styled-components';

interface WelcomeScreenProps {
  onProceed: () => void;
  onNotNow?: () => void; // Marked as optional
}

// Styled components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: white;
  font-family: Arial, sans-serif;
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 16px 20px;
  background-color: #8c35de;
  color: white;
`;

const ProfileIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #b276e5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  margin-right: 12px;
`;

const AppName = styled.span`
  font-size: 20px;
  font-weight: bold;
`;

const LogoContainer = styled.div`
  margin-top: 60px;
  margin-bottom: 40px;
`;

const CircularLogo = styled.div`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background-color: #8c35de;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 32px;
  font-weight: bold;
`;

const WelcomeMessage = styled.div`
  text-align: center;
  margin-bottom: 60px;
  padding: 0 20px;
`;

const Title = styled.h1`
  color: #8c35de;
  font-size: 28px;
  margin-bottom: 16px;
  font-weight: bold;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #333;
  margin: 0;
  line-height: 1.4;
  max-width: 320px;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  max-width: 600px;
  gap: 12px;
`;

const ProceedButton = styled.button`
  background-color: #8c35de;
  color: white;
  border: none;
  border-radius: 30px;
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const NotNowButton = styled.button`
  background-color: #f0f0f0;
  color: #333;
  border: none;
  border-radius: 30px;
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
`;

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onProceed, onNotNow }) => {
  return (
    <Container>
      {/* Header with profile icon and app name */}
      <Header>
        <ProfileIcon>L</ProfileIcon>
        <AppName>LavernAI</AppName>
      </Header>

      {/* Central logo */}
      <LogoContainer>
        <CircularLogo>LAVERN</CircularLogo>
      </LogoContainer>

      {/* Welcome message */}
      <WelcomeMessage>
        <Title>Welcome to LavernAI</Title>
        <Subtitle>You are about to explore the best CBC experience in Kenya.</Subtitle>
      </WelcomeMessage>

      {/* Action buttons */}
      <ButtonGroup>
        <ProceedButton onClick={onProceed}>
          Proceed
        </ProceedButton>
        {onNotNow && (
          <NotNowButton onClick={onNotNow}>
            Not Now
          </NotNowButton>
        )}
      </ButtonGroup>
    </Container>
  );
};

export default WelcomeScreen;